export async function generateAIPreview(prompt: string) {
  const apiKey = process.env.REACT_APP_OPENAI_API_KEY;

  const res = await fetch("https://api.openai.com/v1/completions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${apiKey}`,
    },
    body: JSON.stringify({
    model: 'gpt-4o-mini',
      prompt,
      temperature: 0.8,
     max_tokens: 125
    }),
  });

  const json = await res.json();
  return json.choices?.[0]?.text?.trim() ?? "";
}
